import React from 'react';
import styled from 'styled-components';
import { SdiFile, styles } from '@sdir/sds';

type FileNameProps = {
  fileName?: string;
};

const FileName: React.FC<FileNameProps> = ({ fileName }) => {
  if (!fileName) return <></>;
  return (
    <Wrapper>
      <SdiFile color={styles.colors.primary} size="s" />
      <Name>{fileName}</Name>
    </Wrapper>
  );
};

export default FileName;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 10px 0 5px 0;
`;

const Name = styled.span`
  margin-left: 5px;
  color: ${styles.colors.primary};
`;
